"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateItineraryCourseListAssignment = void 0;
const dayjs = require("dayjs");
const _ = require("lodash");
const models_1 = require("../../models");
const course_1 = require("../course");
const orders_1 = require("../orders");
// TO MOVE
const generateItineraryCourseListAssignment = (active_list, rate_matrix, formData) => {
    // get the list that is
    // get the active list
    const list_to_create = _.cloneDeep(active_list);
    // reverse the list so the 'best' one is played last
    list_to_create.reverse();
    // this is used to get inclusive days for the duration
    const duration_adjustment = 1;
    const duration = formData?.trip?.duration_days_nights || 0;
    // GET THE COURSE DISTRIBUTION ASSIGNMENT
    const course_distribution = (0, course_1.getGolfDayDistribution)(list_to_create.length, formData?.trip?.type === models_1.TripType.GOLF_HOTEL ? duration : duration - 1) || [true];
    // get the date range
    const dates = [];
    // NOTE: If GOLF+HOTEL need to increase the number of days by 1
    for (let i = 0; i < duration + duration_adjustment; i++) {
        dates.push(dayjs(formData.trip?.start_date).add(i, "day").format("YYYY-MM-DD"));
    }
    // CREATE THE COURSES EMPTY ARRAY
    const courses_obj = [];
    // THE LENGTH OF THE COURSES ARRAY SHOULD BE THE SAME AS THE NUMBER OF NIGHTS + 1
    courses_obj.length = duration + duration_adjustment;
    // loop through the course distribution and add the courses to the courses array where the index is true
    course_distribution.forEach((cd, index) => {
        if (cd) {
            const course_id = list_to_create.shift();
            const date = dates[index];
            const todays_matrix = rate_matrix.find((r) => r.date === date);
            const course_rate = todays_matrix?.courses.find((c) => c.config.course?.id === course_id);
            const obj = course_rate;
            courses_obj[index] = obj;
        }
    });
    // Optimise
    const matrix = rate_matrix.map(({ date, courses }) => courses.length > 0 && {
        date,
        courses: courses.map((course) => ({
            id: course.config.course.id,
            name: course.config.course.name,
            nickname: course.config.course.nickname,
            players: course.config?.where_when_who?.number_of_golfers,
            rate: (0, orders_1.getOrderLineTotalByType)(course.config, "GOLF"),
            rate_message: course.message,
        })),
    });
    //array is false, set the rate to 0 for each course
    matrix.forEach((m, i) => {
        if (!course_distribution[i]) {
            m?.courses?.forEach((c) => {
                c.rate = 0;
            });
        }
    });
    const ideal_order = _.cloneDeep(active_list);
    const cheapest_combination = (0, course_1.findCheapestCombination)(ideal_order.reverse(), courses_obj.map((x) => x?.config?.course?.id), matrix);
    const sorted_itinerary = (0, course_1.sortGolfData)(courses_obj, cheapest_combination);
    // go through each item and update the date
    const new_itinerary = sorted_itinerary.map((golf, index) => {
        if (!golf)
            return null;
        return {
            ...golf,
            config: {
                ...golf.config,
                where_when_who: {
                    ...golf.config?.where_when_who,
                    date: dates[index],
                },
            },
        };
    });
    // loop through the itinerary and get updated and applicable rate from the rate matrix for that date and course
    const updated_itinerary = new_itinerary.map((golf) => {
        if (!golf)
            return null;
        const date = dayjs(golf?.config?.where_when_who?.date).format("YYYY-MM-DD");
        const todays_matrix = rate_matrix.find((r) => r.date === date);
        const course_rate = todays_matrix?.courses.find((c) => c.config.course?.id === golf?.config.course?.id);
        return course_rate;
    });
    return updated_itinerary;
};
exports.generateItineraryCourseListAssignment = generateItineraryCourseListAssignment;
